import { useMutation, gql } from "@apollo/client";

const NewsletterRegisterMutation = gql`
  mutation NewsletterRegister(
    $gender: String
    $firstName: String
    $lastName: String
    $emailAddress: String!
    $reCaptcha: String
  ) {
    newsletterRegister(
      gender: $gender
      firstName: $firstName
      lastName: $lastName
      emailAddress: $emailAddress
      reCaptcha: $reCaptcha
    )
  }
`;

const useSubscribeToNewsLetter = () => {
  const [newsletterRegisterMutation, { loading }] = useMutation(
    NewsletterRegisterMutation,
  );

  const subscribeToNewsLetter = async ({
    gender,
    firstName,
    lastName,
    emailAddress,
    reCaptcha,
  }) => {
    const { data } = await newsletterRegisterMutation({
      variables: { gender, firstName, lastName, emailAddress, reCaptcha },
    });
    return data?.newsletterRegister;
  };

  return {
    subscribeToNewsLetter,
    loading,
  };
};

export default useSubscribeToNewsLetter;
